import React, { useContext } from 'react'
import { GlobalSiteDataContext } from '../../context'
import {
    Faqs,
    FaqsHero,
    FaqsForm,
    FaqsStructuredData,
    SEO,
} from '../../components'
import { graphql } from 'gatsby'
import './process.css'

function FaqsPage() {
    const siteData = useContext(GlobalSiteDataContext)
    return (
        <main id="faqs-page">
            <FaqsHero />
            <Faqs
                milanOpenStores={siteData.milanOpenStores}
                globalData={siteData.globalData}
            />
            <FaqsForm siteData={siteData} />
        </main>
    )
}

export const Head = ({ data, location }) => {
    const query = data.siteDataJson
    return (
        <>
            <FaqsStructuredData />
            <SEO
                location={location}
                origin={query.origin}
                title={`FAQs About Laser Hair Removal | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
                description="Get all your laser hair removal questions answered in one place! Our FAQ page covers everything you need to know about this popular treatment. Say goodbye to unwanted hair today!"
            />
        </>
    )
}

export const query = graphql`
    {
        siteDataJson {
            name
            stateAbbrev
            origin
        }
    }
`

export default FaqsPage
